module.exports = __webpack_public_path__ + "img/icon_sub@2x.1d7d2939.png";